import LoadingContainer from './Loading.container';

export default LoadingContainer;
